// Site-wide content defaults (EN + FR); admin: Website → Navbar, footer & offices.
// nav: navbar + mobile menu · footer: link columns, office locations, bottom line · social ·
// accreditations · promises: the service promises shown in the page text through tokens
// ({quoteReply}, {urgent}, …; src/utils/promises.js) · coverage: the homepage coverage map
// (a city's "response" is {urgentShort}: ~1 hr in Montréal, ~4 hrs elsewhere) · offices: the
// office card on the city pages (src/data/offices.js) · callModal: the "Call us" pop-up · reviews / reviewItems:
// the client reviews on the city pages (no reviews here: an empty list shows the homepage
// reviews). Empty admin fields fall back to these, field by field.
// Values shown in both languages are stored once, on the English side: links (a site page
// is its English path, made French by localizePath unless a French link is given; "/#services"
// scrolls to a homepage section), the "call" pop-up item, phone numbers, the office email (a
// mailto: link) and social links. {year} and {city} are filled in by the page. Logos and the
// province images stay bundled (not listed here) until a file is uploaded in the admin.
const GLOBAL_DEFAULTS = {
  "en": {
    "nav": {
      "items": [
        {
          "label": "About",
          "link": "/about",
          "links": [
            {
              "label": "About Us",
              "link": "/about"
            },
            {
              "label": "Foundation",
              "link": "/blog/foundation"
            },
            {
              "label": "Blog",
              "link": "/blog"
            }
          ]
        },
        {
          "label": "Jobs",
          "link": "/#about",
          "links": [
            {
              "label": "Apply",
              "link": "/careers"
            },
            {
              "label": "Careers",
              "link": "/security-careers"
            }
          ]
        },
        {
          "label": "Services",
          "link": "/#services",
          "links": [
            {
              "label": "Security Guards",
              "link": "/services/security-guards"
            },
            {
              "label": "Security Systems",
              "link": "/services/security-systems"
            },
            {
              "label": "Staffing Solutions",
              "link": "/services/security-staffing"
            },
            {
              "label": "Hybrid Solutions",
              "link": "/services/hybrid-security-solutions"
            },
            {
              "label": "Transportation",
              "link": "/services/transportation-security"
            },
            {
              "label": "Intervention Services",
              "link": "/services/crisis-intervention-security"
            }
          ]
        },
        {
          "label": "Categories",
          "link": "/#services",
          "links": [
            {
              "label": "Event Security",
              "link": "/services/event-security"
            },
            {
              "label": "Residential Security",
              "link": "/services/residential-security"
            },
            {
              "label": "Traffic Control",
              "link": "/services/traffic-control"
            },
            {
              "label": "Fire Surveillance",
              "link": "/services/fire-watch-security"
            },
            {
              "label": "Hospitality Services",
              "link": "/services/hospitality-security"
            },
            {
              "label": "VIP Security",
              "link": "/services/luxury-security"
            },
            {
              "label": "Loss Prevention",
              "link": "/services/loss-prevention"
            },
            {
              "label": "Construction Site Security",
              "link": "/services/construction-site-security"
            },
            {
              "label": "Patrol Services",
              "link": "/services/patrol-services"
            },
            {
              "label": "Commercial Properties",
              "link": "/services/commercial-properties"
            },
            {
              "label": "Educational Sector",
              "link": "/services/education-security"
            },
            {
              "label": "Government Services",
              "link": "/services/government-services"
            }
          ]
        },
        {
          "label": "Locations",
          "links": [
            {
              "label": "Montréal",
              "link": "/montreal"
            },
            {
              "label": "Québec City",
              "link": "/quebec-city"
            },
            {
              "label": "Trois-Rivières",
              "link": "/trois-rivieres"
            },
            {
              "label": "Toronto",
              "link": "/toronto"
            },
            {
              "label": "Ottawa",
              "link": "/ottawa"
            },
            {
              "label": "Niagara Falls",
              "link": "/niagara-falls"
            }
          ]
        },
        {
          "label": "Get a Quote",
          "link": "/#team",
          "links": [
            {
              "label": "Request a Quote",
              "link": "/contact#quote-request"
            },
            {
              "label": "Consultation Call",
              "type": "call"
            }
          ]
        }
      ]
    },
    "footer": {
      "columns": [
        {
          "title": "Locations",
          "links": [
            {
              "label": "Montréal",
              "link": "/montreal"
            },
            {
              "label": "Laval",
              "link": "/laval"
            },
            {
              "label": "Québec City",
              "link": "/quebec-city"
            },
            {
              "label": "Trois-Rivières",
              "link": "/trois-rivieres"
            },
            {
              "label": "Toronto",
              "link": "/toronto"
            },
            {
              "label": "Ottawa",
              "link": "/ottawa"
            },
            {
              "label": "Niagara Falls",
              "link": "/niagara-falls"
            }
          ]
        },
        {
          "title": "Jobs",
          "links": [
            {
              "label": "Apply",
              "link": "/careers"
            },
            {
              "label": "Montreal",
              "link": "/montreal"
            }
          ]
        },
        {
          "title": "Services",
          "links": [
            {
              "label": "Security Guards",
              "link": "/services/security-guards"
            },
            {
              "label": "Security Systems",
              "link": "/services/security-systems"
            },
            {
              "label": "Staffing Solutions",
              "link": "/services/security-staffing"
            },
            {
              "label": "Hybrid Solutions",
              "link": "/services/hybrid-security-solutions"
            },
            {
              "label": "Transportation",
              "link": "/services/transportation-security"
            },
            {
              "label": "Intervention Services",
              "link": "/services/crisis-intervention-security"
            }
          ]
        },
        {
          "title": "Categories",
          "links": [
            {
              "label": "Event Security",
              "link": "/services/event-security"
            },
            {
              "label": "Residential Security",
              "link": "/services/residential-security"
            },
            {
              "label": "Traffic Control",
              "link": "/services/traffic-control"
            },
            {
              "label": "Fire Surveillance",
              "link": "/services/fire-watch-security"
            },
            {
              "label": "Hospitality Services",
              "link": "/services/hospitality-security"
            },
            {
              "label": "VIP Security",
              "link": "/services/luxury-security"
            },
            {
              "label": "Loss Prevention",
              "link": "/services/loss-prevention"
            },
            {
              "label": "Construction Site Security",
              "link": "/services/construction-site-security"
            },
            {
              "label": "Patrol Services",
              "link": "/services/patrol-services"
            },
            {
              "label": "Commercial Properties",
              "link": "/services/commercial-properties"
            },
            {
              "label": "Educational Sector",
              "link": "/services/education-security"
            },
            {
              "label": "Government Services",
              "link": "/services/government-services"
            }
          ]
        },
        {
          "title": "Get a Quote",
          "links": [
            {
              "label": "Request a Quote",
              "link": "/contact#quote-request"
            },
            {
              "label": "Consultation Call",
              "link": "/contact"
            }
          ]
        }
      ],
      "locationsTitle": "Office Locations",
      "locations": [
        {
          "name": "Quebec",
          "address": "Suite 620-3285 Boul Cavendish, Montreal, QC H4B 2L9",
          "alt": "Quebec",
          "phones": [
            {
              "phone": "514-279-7209"
            }
          ],
          "link": "mailto:info@securityvision.ca"
        },
        {
          "name": "Ontario",
          "address": "Suite 200-150 King Street West, Toronto, ON M5H 1J9",
          "alt": "Ontario",
          "phones": [
            {
              "phone": "416-588-0180"
            },
            {
              "phone": "613-667-3388"
            }
          ],
          "link": "mailto:info@securityvision.ca"
        }
      ],
      "copyright": "© {year} Vision Security — All rights reserved.",
      "legal": [
        {
          "label": "Privacy Policy",
          "link": "/privacy"
        },
        {
          "label": "Terms of Service",
          "link": "/terms"
        },
        {
          "label": "Compliance & Licensing",
          "link": "/compliance"
        },
        {
          "label": "Industries",
          "link": "/industries/healthcare-security"
        },
        {
          "label": "Case Studies",
          "link": "/case-studies"
        }
      ]
    },
    "social": [
      {
        "type": "facebook",
        "link": "https://www.facebook.com/p/Visionsecurite-100079664496184/"
      },
      {
        "type": "instagram",
        "link": "https://www.instagram.com/visionsecurity.inc/?hl=en"
      },
      {
        "type": "linkedin",
        "link": "https://www.linkedin.com/company/vision-s%C3%A9curit%C3%A9-inc/posts/?feedView=all"
      },
      {
        "type": "youtube",
        "link": "https://www.youtube.com/@VisionSecurityInc"
      }
    ],
    "accreditations": {
      "title": "Accreditations & Certifications",
      "items": [
        {
          "alt": "CNESST – Québec workplace health and safety board"
        },
        {
          "alt": "Ontario licence under the Private Security and Investigative Services Act, 2005"
        },
        {
          "alt": "Comité paritaire des agents de sécurité (CPAS), Québec security guard joint committee"
        },
        {
          "alt": "BSP Certification"
        },
        {
          "alt": "OQLF Certification"
        },
        {
          "alt": "WSIB workplace safety insurance certification"
        }
      ]
    },
    "coverage": {
      "eyebrow": "Our coverage",
      "title": "Professional security coverage across",
      "titleEm": "Québec and Ontario.",
      "subtitle": "Select a city to preview local coverage and visit the dedicated service page.",
      "chooseLabel": "Choose a city",
      "prevLabel": "Previous city",
      "nextLabel": "Next city",
      "responseLabel": "Urgent staffing",
      "guardsLabel": "Licensed guards",
      "officeLabel": "Office",
      "localLineLabel": "Local line",
      "viewLabel": "View {city} page",
      "mapLabel": "Coverage map of Québec and Ontario",
      "cityLegend": "City served",
      "dispatchLabel": "24/7 dispatch",
      "cities": {
        "montreal": {
          "name": "Montréal",
          "label": "Headquarters",
          "response": "{urgentShort}",
          "guards": "500+",
          "headline": "Our headquarters deploys bilingual guards 24/7 across downtown, Old Port, the Plateau and the South Shore — covering office towers, festivals, construction sites and industrial facilities.",
          "services": [
            {
              "text": "Office towers"
            },
            {
              "text": "Events"
            },
            {
              "text": "Construction"
            },
            {
              "text": "Mobile patrol"
            }
          ],
          "phone": "514-279-7209"
        },
        "laval": {
          "name": "Laval",
          "label": "Greater Montréal",
          "response": "{urgentShort}",
          "guards": "500+",
          "headline": "Dedicated coverage north of the Rivière des Prairies — Carrefour Laval, Centropolis, Chomedey industrial parks and Sainte-Dorothée residential complexes.",
          "services": [
            {
              "text": "Retail"
            },
            {
              "text": "Condominiums"
            },
            {
              "text": "Patrol"
            },
            {
              "text": "Concierge"
            }
          ],
          "phone": "514-279-7209"
        },
        "quebec-city": {
          "name": "Québec City",
          "label": "Québec Capital",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Trained agents for Old Québec, Parliament Hill, Sainte-Foy and the Port — provincial institutions, heritage hotels, cruise terminals and flagship events.",
          "services": [
            {
              "text": "Government"
            },
            {
              "text": "Hospitality"
            },
            {
              "text": "Events"
            },
            {
              "text": "Tourism"
            }
          ],
          "phone": "514-279-7209"
        },
        "trois-rivieres": {
          "name": "Trois-Rivières",
          "label": "Central Québec",
          "response": "{urgentShort}",
          "guards": "40+",
          "headline": "Strategic midpoint between Montréal and Québec City — pulp & paper mills, industrial parks, river-port sites and regional deployments across Mauricie.",
          "services": [
            {
              "text": "Industrial"
            },
            {
              "text": "Manufacturing"
            },
            {
              "text": "Sites"
            },
            {
              "text": "Patrol"
            }
          ],
          "phone": "514-279-7209"
        },
        "ottawa": {
          "name": "Ottawa",
          "label": "National Capital Region",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Licensed bilingual teams for Parliament Hill, ByWard Market, Kanata Tech Park and embassy row — corporate, government and diplomatic environments.",
          "services": [
            {
              "text": "Corporate"
            },
            {
              "text": "Government"
            },
            {
              "text": "Diplomatic"
            },
            {
              "text": "Tech"
            }
          ],
          "phone": "613-667-3388"
        },
        "toronto": {
          "name": "Toronto",
          "label": "Ontario Hub",
          "response": "{urgentShort}",
          "guards": "300+",
          "headline": "PSISA-licensed guards across the Financial District, King West, Yorkville and the Waterfront — condo towers, events, luxury retail and major construction sites.",
          "services": [
            {
              "text": "Concierge"
            },
            {
              "text": "Condos"
            },
            {
              "text": "Retail"
            },
            {
              "text": "Events"
            }
          ],
          "phone": "416-588-0180"
        },
        "niagara-falls": {
          "name": "Niagara Falls",
          "label": "Southwestern Ontario",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Specialized coverage for Clifton Hill, Fallsview, casino resorts, hotels and the Niagara-on-the-Lake wine region — crowd, hospitality and event security.",
          "services": [
            {
              "text": "Hospitality"
            },
            {
              "text": "Casinos"
            },
            {
              "text": "Crowd"
            },
            {
              "text": "Events"
            }
          ],
          "phone": "416-588-0180"
        }
      }
    },
    "offices": {
      "montreal": {
        "name": "Montréal headquarters",
        "address": "Suite 620-3285 Boul. Cavendish\nMontréal, QC H4B 2L9"
      },
      "toronto": {
        "name": "Toronto office",
        "address": "Suite 200-150 King Street West\nToronto, ON M5H 1J9"
      }
    },
    "promises": {
      "dispatch": "phones answered 24/7",
      "quoteReply": "within 24 hours",
      "urgentMontreal": "typically within 1 hour",
      "urgentOther": "typically within 4 hours",
      "urgentAll": "typically within 1 hour in Montréal and 4 hours elsewhere",
      "urgentShortMontreal": "~1 hr",
      "urgentShortOther": "~4 hrs",
      "urgentShortAll": "1–4 hrs",
      "plannedStart": "typically 24–48 hours after signing",
      "alarm": "24/7 alarm response by mobile patrol"
    },
    "callModal": {
      "brand": "Vision Sécurité",
      "tag": "Confidential",
      "title": "Schedule a Consultation",
      "subtitle": "Connect with a senior security advisor for a complimentary, no-obligation assessment of your security requirements.",
      "phones": [
        {
          "label": "Montreal",
          "phone": "514-279-7209"
        },
        {
          "label": "Toronto",
          "phone": "416-588-0180"
        },
        {
          "label": "Ottawa",
          "phone": "613-667-3388"
        }
      ],
      "emailLabel": "Email",
      "link": "mailto:info@securityvision.ca",
      "quoteLabel": "Request a quote",
      "quoteValue": "Online form",
      "hours": "Open 24 hours, 7 days a week",
      "emergency": "Urgent requests: {dispatch}, for clients and new requests alike"
    },
    "reviews": {
      "title": "What our clients say",
      "subtitle": "Reviews from the businesses and organizations that trust Vision with their security.",
      "countLabel": "{rating} on Google · {count} reviews",
      "linkLabel": "See all our reviews on Google",
      "quebec": { "link": "https://g.page/r/Cehhu8Rr9JhKEBM/", "rating": "5.0" },
      "ontario": { "link": "https://g.page/r/CQIA-8yeDnDVEBM/", "rating": "5.0", "reviewCount": "22" }
    },
    "reviewItems": []
  },
  "fr": {
    "nav": {
      "items": [
        {
          "label": "About",
          "links": [
            {
              "label": "About Us"
            },
            {
              "label": "Foundation"
            },
            {
              "label": "Blog"
            }
          ]
        },
        {
          "label": "Emplois",
          "links": [
            {
              "label": "Postuler"
            },
            {
              "label": "Carrières"
            }
          ]
        },
        {
          "label": "Services",
          "links": [
            {
              "label": "Agents de sécurité"
            },
            {
              "label": "Systèmes de sécurité"
            },
            {
              "label": "Solutions de personnel"
            },
            {
              "label": "Solutions hybrides"
            },
            {
              "label": "Transport"
            },
            {
              "label": "Services d'intervention"
            }
          ]
        },
        {
          "label": "Catégories",
          "links": [
            {
              "label": "Sécurité d'événements"
            },
            {
              "label": "Sécurité résidentielle"
            },
            {
              "label": "Contrôle de la circulation"
            },
            {
              "label": "Surveillance incendie"
            },
            {
              "label": "Services d'accueil"
            },
            {
              "label": "Sécurité VIP"
            },
            {
              "label": "Prévention des pertes"
            },
            {
              "label": "Sécurité de chantier"
            },
            {
              "label": "Services de patrouille"
            },
            {
              "label": "Propriétés commerciales"
            },
            {
              "label": "Secteur éducatif"
            },
            {
              "label": "Services gouvernementaux"
            }
          ]
        },
        {
          "label": "Locations",
          "links": [
            {
              "label": "Montréal"
            },
            {
              "label": "Québec City"
            },
            {
              "label": "Trois-Rivières"
            },
            {
              "label": "Toronto"
            },
            {
              "label": "Ottawa"
            },
            {
              "label": "Niagara Falls"
            }
          ]
        },
        {
          "label": "Obtenir un devis",
          "links": [
            {
              "label": "Demander un devis"
            },
            {
              "label": "Appel de consultation"
            }
          ]
        }
      ]
    },
    "footer": {
      "columns": [
        {
          "title": "Locations",
          "links": [
            {
              "label": "Montréal"
            },
            {
              "label": "Laval"
            },
            {
              "label": "Québec City"
            },
            {
              "label": "Trois-Rivières"
            },
            {
              "label": "Toronto"
            },
            {
              "label": "Ottawa"
            },
            {
              "label": "Niagara Falls"
            }
          ]
        },
        {
          "title": "Emplois",
          "links": [
            {
              "label": "Postuler"
            },
            {
              "label": "Montreal"
            }
          ]
        },
        {
          "title": "Services",
          "links": [
            {
              "label": "Agents de sécurité"
            },
            {
              "label": "Systèmes de sécurité"
            },
            {
              "label": "Solutions de personnel"
            },
            {
              "label": "Solutions hybrides"
            },
            {
              "label": "Transport"
            },
            {
              "label": "Services d'intervention"
            }
          ]
        },
        {
          "title": "Catégories",
          "links": [
            {
              "label": "Sécurité d'événements"
            },
            {
              "label": "Sécurité résidentielle"
            },
            {
              "label": "Contrôle de la circulation"
            },
            {
              "label": "Surveillance incendie"
            },
            {
              "label": "Services d'accueil"
            },
            {
              "label": "Sécurité VIP"
            },
            {
              "label": "Prévention des pertes"
            },
            {
              "label": "Sécurité de chantier"
            },
            {
              "label": "Services de patrouille"
            },
            {
              "label": "Propriétés commerciales"
            },
            {
              "label": "Secteur éducatif"
            },
            {
              "label": "Services gouvernementaux"
            }
          ]
        },
        {
          "title": "Obtenir un devis",
          "links": [
            {
              "label": "Demander un devis"
            },
            {
              "label": "Appel de consultation"
            }
          ]
        }
      ],
      "locationsTitle": "Bureaux",
      "locations": [
        {
          "name": "Québec",
          "address": "Suite 620-3285 boul. Cavendish, Montréal (QC) H4B 2L9",
          "alt": "Québec"
        },
        {
          "name": "Ontario",
          "address": "Suite 200-150 King Street West, Toronto (ON) M5H 1J9",
          "alt": "Ontario"
        }
      ],
      "copyright": "© {year} Vision Security — Tous droits réservés.",
      "legal": [
        {
          "label": "Privacy Policy"
        },
        {
          "label": "Terms of Service"
        },
        {
          "label": "Conformité et permis",
          "link": "/fr/conformite"
        },
        {
          "label": "Secteurs",
          "link": "/fr/industries/securite-sante"
        },
        {
          "label": "Études de cas",
          "link": "/fr/etudes-de-cas"
        }
      ]
    },
    "accreditations": {
      "title": "Accréditations et certifications",
      "items": [
        {
          "alt": "CNESST – Commission des normes, de l'équité, de la santé et de la sécurité du travail"
        },
        {
          "alt": "Permis de l'Ontario en vertu de la Loi de 2005 sur les services privés de sécurité et d'enquête"
        },
        {
          "alt": "Comité paritaire des agents de sécurité (CPAS)"
        },
        {
          "alt": "Certification BSP"
        },
        {
          "alt": "Certification OQLF"
        },
        {
          "alt": "CSPAAT (WSIB) – assurance contre les accidents du travail de l'Ontario"
        }
      ]
    },
    "coverage": {
      "eyebrow": "Notre couverture",
      "title": "Couverture professionnelle en",
      "titleEm": "Québec et en Ontario.",
      "subtitle": "Sélectionnez une ville pour voir la couverture locale et accéder à la page de service dédiée.",
      "chooseLabel": "Choisir une ville",
      "prevLabel": "Ville précédente",
      "nextLabel": "Ville suivante",
      "responseLabel": "Déploiement urgent",
      "guardsLabel": "Agents licenciés",
      "officeLabel": "Bureau",
      "localLineLabel": "Ligne locale",
      "viewLabel": "Voir la page {city}",
      "mapLabel": "Carte de couverture Québec et Ontario",
      "cityLegend": "Ville desservie",
      "dispatchLabel": "Répartition 24/7",
      "cities": {
        "montreal": {
          "name": "Montréal",
          "label": "Siège social",
          "response": "{urgentShort}",
          "guards": "500+",
          "headline": "Notre siège social déploie des agents bilingues 24/7 dans le centre-ville, le Vieux-Port, le Plateau et la Rive-Sud — pour tours de bureaux, festivals, chantiers et sites industriels.",
          "services": [
            {
              "text": "Tours de bureaux"
            },
            {
              "text": "Événements"
            },
            {
              "text": "Construction"
            },
            {
              "text": "Patrouille mobile"
            }
          ]
        },
        "laval": {
          "name": "Laval",
          "label": "Grand Montréal",
          "response": "{urgentShort}",
          "guards": "500+",
          "headline": "Couverture dédiée au nord de la rivière des Prairies : Carrefour Laval, Centropolis, parcs industriels de Chomedey et complexes résidentiels de Sainte-Dorothée.",
          "services": [
            {
              "text": "Commerce de détail"
            },
            {
              "text": "Condos"
            },
            {
              "text": "Patrouille"
            },
            {
              "text": "Concierge"
            }
          ]
        },
        "quebec-city": {
          "name": "Québec",
          "label": "Capitale-Nationale",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Agents formés pour le Vieux-Québec, la colline Parlementaire, Sainte-Foy et le Port — institutions provinciales, hôtels patrimoniaux, croisières et événements majeurs.",
          "services": [
            {
              "text": "Gouvernement"
            },
            {
              "text": "Hôtellerie"
            },
            {
              "text": "Événements"
            },
            {
              "text": "Tourisme"
            }
          ]
        },
        "trois-rivieres": {
          "name": "Trois-Rivières",
          "label": "Centre du Québec",
          "response": "{urgentShort}",
          "guards": "40+",
          "headline": "Position stratégique à mi-chemin entre Montréal et Québec : papeteries, parcs industriels, sites du port et déploiements régionaux en Mauricie.",
          "services": [
            {
              "text": "Industriel"
            },
            {
              "text": "Manufacturier"
            },
            {
              "text": "Sites"
            },
            {
              "text": "Patrouille"
            }
          ]
        },
        "ottawa": {
          "name": "Ottawa",
          "label": "Région de la capitale nationale",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Équipes bilingues licenciées pour la Colline du Parlement, ByWard, Kanata Tech Park et les ambassades — environnements corporatifs, gouvernementaux et diplomatiques.",
          "services": [
            {
              "text": "Corporatif"
            },
            {
              "text": "Gouvernement"
            },
            {
              "text": "Diplomatique"
            },
            {
              "text": "Tech"
            }
          ]
        },
        "toronto": {
          "name": "Toronto",
          "label": "Pôle ontarien",
          "response": "{urgentShort}",
          "guards": "300+",
          "headline": "Agents titulaires d’un permis PSISA pour le Financial District, King West, Yorkville et le Waterfront — tours de condos, événements, commerces de luxe et chantiers majeurs.",
          "services": [
            {
              "text": "Concierge"
            },
            {
              "text": "Condos"
            },
            {
              "text": "Commerce"
            },
            {
              "text": "Événements"
            }
          ]
        },
        "niagara-falls": {
          "name": "Niagara Falls",
          "label": "Sud-ouest de l'Ontario",
          "response": "{urgentShort}",
          "guards": "100+",
          "headline": "Sécurité spécialisée pour Clifton Hill, Fallsview, les casinos, hôtels et la région viticole de Niagara-on-the-Lake — événements, foule et hôtellerie haut de gamme.",
          "services": [
            {
              "text": "Hôtellerie"
            },
            {
              "text": "Casinos"
            },
            {
              "text": "Foule"
            },
            {
              "text": "Événements"
            }
          ]
        }
      }
    },
    "offices": {
      "montreal": {
        "name": "Siège social de Montréal",
        "address": "Suite 620-3285, boul. Cavendish\nMontréal (QC) H4B 2L9"
      },
      "toronto": {
        "name": "Bureau de Toronto",
        "address": "Suite 200-150, King Street West\nToronto (ON) M5H 1J9"
      }
    },
    "promises": {
      "dispatch": "réponse téléphonique 24/7",
      "quoteReply": "sous 24 heures",
      "urgentMontreal": "généralement en moins d'une heure",
      "urgentOther": "généralement en moins de 4 heures",
      "urgentAll": "généralement en moins d'une heure à Montréal et de 4 heures ailleurs",
      "urgentShortMontreal": "~1 h",
      "urgentShortOther": "~4 h",
      "urgentShortAll": "1 à 4 h",
      "plannedStart": "généralement 24 à 48 heures après la signature",
      "alarm": "intervention sur alarme 24/7 par patrouille mobile"
    },
    "callModal": {
      "brand": "Vision Sécurité",
      "tag": "Confidentiel",
      "title": "Planifier une consultation",
      "subtitle": "Parlez à un conseiller en sécurité principal pour une évaluation gratuite et sans engagement de vos besoins en sécurité.",
      "phones": [
        {
          "label": "Montréal"
        },
        {
          "label": "Toronto"
        },
        {
          "label": "Ottawa"
        }
      ],
      "emailLabel": "Courriel",
      "quoteLabel": "Demander une soumission",
      "quoteValue": "Formulaire en ligne",
      "hours": "Ouvert 24 h sur 24, 7 jours sur 7",
      "emergency": "Demandes urgentes : {dispatch}, pour les clients comme pour les nouvelles demandes"
    },
    "reviews": {
      "title": "Ce que disent nos clients",
      "subtitle": "Les avis des entreprises et organisations qui confient leur sécurité à Vision.",
      "countLabel": "{rating} sur Google · {count} avis",
      "linkLabel": "Voir tous nos avis sur Google"
    }
  }
};

export default GLOBAL_DEFAULTS;
